import styled from 'styled-components'


export const _SwiperWrapper = styled.span`
  width: 100%;

  position: relative;

  ${({ canScrollNext }) => (canScrollNext ? '' : `
      .embla__button--next {
        opacity: 0 !important;
      }
    `)}

  ${({ canScrollPrev }) => (canScrollPrev ? '' : `
      .embla__button--prev {
        opacity: 0 !important;
      }
    `)}


  .embla__slide {
    width: auto;
    flex-shrink: 0 !important;
  }
`
